import {
  BUILDER_PATH_TRIAL_DAYS,
  OnboardingUserType,
} from '@super/shared-types'

interface PathPromiseProps {
  userType: OnboardingUserType | null
  trialDays: number | null
}

export function PathPromise({ userType }: PathPromiseProps) {
  if (userType === OnboardingUserType.STANDARD_USER) {
    return (
      <p className="text-muted-foreground ml-3 text-xs">
        Your card will not be charged until you connect with our team and
        confirm. Ask us about our first month discount during onboarding.
      </p>
    )
  }

  return (
    <p className="text-muted-foreground ml-3 text-xs">
      {BUILDER_PATH_TRIAL_DAYS} day free trial for quick setup. Cancel your
      subscription before your trial ends to not be charged.
    </p>
  )
}
